<template>
	<div class="APPdevelopment">
		<div class="swiper-container APPswiper" style="width: 100vw;height: 100vh;overflow: hidden;">
			<div class="swiper-wrapper">
				<!-- 第一屏 -->
				<div class="swiper-slide swiper-no-swiping" style="width: 100vw;height: 100vh;">
					<Banner></Banner>
				</div>
				<!-- 第二屏 -->
				<div class="swiper-slide swiper-no-swiping" style="width: 100vw;height: 100vh;">
					<div style="height: 100%" data-scroll="true">

						<el-scrollbar ref="APPscroll" style="height: 100%">
							<div style="margin-bottom:0.4167rem;margin-top:0.3646rem">
								<div class="title_box">APP定制开发服务</div>
								<div class="title_info">专注定制体验流畅、性能响应快、设计主流前卫等优质特性的APP移动端应用软件</div>
								<div class="development">
									<div class="IOS phone">
										<div class="img_box"></div>
										<div class="title">IOS开发</div>
										<div class="text_info">专注于高端iOS苹果APP开发定制，为广大中小型企业打造最好的产品</div>
									</div>
									<div class="Android phone">
										<div class="img_box"></div>
										<div class="title">Android开发</div>
										<div class="text_info">致力于安卓APP应用软件开发，采用主流前沿框架与技术，并支持安卓系统各厂商各版本的兼容</div>
									</div>
								</div>
							</div>
							<div style="margin-bottom:0.4167rem;">
								<div class="title_box">APP的四大优势</div>
								<div class="title_info">精准营销、用户粘性强、成本低、流量多</div>
								<div class="advantage_box">
									<div class="advantage_li">
										<div class="img_box">
											<img src="../../static/images/img/jingzhun.png" alt="">
										</div>
										<div class="title">精准营销</div>
										<div class="text_info">
											APP可以将企业的最新信息快速精准的传达给目标客户。例如，公司最近的新产品上市或优惠促销活动等信息，都可以通过手机APP第一时间传达给客户，这种传达方式，既精准又高效。
										</div>
									</div>
									<div class="advantage_li">
										<div class="img_box">
											<img src="../../static/images/img/nianxing.png" alt="">
										</div>
										<div class="title">用户粘性强</div>
										<div class="text_info">
											APP营销的粘性在于一旦用户将应用下载到手机，应用中的内容和趣味活动会吸引用户，形成用户粘性；如果APP拥有较好的用户体验，则会提升用户的忠诚度和活跃度。
										</div>
									</div>
									<div class="advantage_li">
										<div class="img_box">
											<img src="../../static/images/img/chengben.png" alt="">
										</div>
										<div class="title">成本低</div>
										<div class="text_info">
											APP能让企业用低的广告成本，获得网站宣传效果。APP广告无需按点击和播放次数付费，其图文并茂、形象生动的广告表现形式，实现费用和效果上的一举两得。
										</div>
									</div>
									<div class="advantage_li">
										<div class="img_box">
											<img src="../../static/images/img/liuliang.png" alt="">
										</div>
										<div class="title">流量多</div>
										<div class="text_info">
											网络统计数据表明：企业APP带来的客户访问量远远超过了传统互联网（电脑端）的流量，通过企业APP进行盈利也是各行业的发展方向。
										</div>
									</div>
								</div>
							</div>
							<div style="margin-bottom:0.4167rem;">
								<div class="title_box">服务类型</div>
								<div class="title_info">商城营销、餐饮类、旅游即时通讯、医疗、教育等各种类型的APP</div>
								<div class="type_box">
									<div class="type_li">
										<div class="img_box">
											<img src="../../static/images/img/jiaoyu.png" alt="">
										</div>
										<div class="title">教育类APP</div>
										<div class="text_info">目前庞大的手机用户基数，促使了 智能手机APP的井喷式诞生。移动商城类是集合产品展示、 推荐等功能</div>
									</div>
									<div class="type_li">
										<div class="img_box">
											<img src="../../static/images/img/dianshang.png" alt="">
										</div>
										<div class="title">电商类APP</div>
										<div class="text_info">目前庞大的手机用户基数，促使了 智能手机APP的井喷式诞生。移动商城类是集合产品展示、 推荐等功能</div>
									</div>
									<div class="type_li">
										<div class="img_box">
											<img src="../../static/images/img/yimei.png" alt="">
										</div>
										<div class="title">医美类APP</div>
										<div class="text_info">移动医疗被称为“王冠上的明珠” 是卫生部的重点关注项目。在未来 三五年，移动医疗应用建设将会不 断加快</div>
									</div>
									<div class="type_li">
										<div class="img_box">
											<img src="../../static/images/img/lvyou.png" alt="">
										</div>
										<div class="title">旅游类APP</div>
										<div class="text_info">智旅游APP是为和用户提供旅游攻略、旅游指南等旅游服务的手机应用、为用户出行带来无限便利。</div>
									</div>
									<div class="type_li">
										<div class="img_box">
											<img src="../../static/images/img/shenghuo.png" alt="">
										</div>
										<div class="title">生活类APP</div>
										<div class="text_info">生活服务行业的客户人群明确，而且市 场用户基数庞大，因此是个市场广 阔且发展前景光明的行业</div>
									</div>
									<div class="type_li">
										<div class="img_box">
											<img src="../../static/images/img/dichan.png" alt="">
										</div>
										<div class="title">地产类APP</div>
										<div class="text_info">借力互联网，进军房地产！买房卖房租房，一站搞定，随时随地，
											享尽先机</div>
									</div>
									<div class="type_li">
										<div class="img_box">
											<img src="../../static/images/img/shejiao.png" alt="">
										</div>
										<div class="title">社交类APP</div>
										<div class="text_info">社交是人们的基础需求，有人毕然有社交。一款社交APP必须具备明确的目标人群，满足目前人群的核心需求</div>
									</div>
									<div class="type_li">
										<div class="img_box">
											<img src="../../static/images/img/shengxian.png" alt="">
										</div>
										<div class="title">生鲜类APP</div>
										<div class="text_info">智能手机的普及，使得人们习惯先从餐饮美食APP中寻找信息，确定选择自己想要的下单，省时省力</div>
									</div>
									<div class="type_li">
										<div class="img_box">
											<img src="../../static/images/img/jiakao.png" alt="">
										</div>
										<div class="title">驾考类APP</div>
										<div class="text_info">随着当前移动互联a网的发展，驾考APP的优势也凸显出来了。随时随地学车刷题模拟考试节省了很多时间</div>
									</div>
									<div class="type_li">
										<div class="img_box">
											<img src="../../static/images/img/qiye.png" alt="">
										</div>
										<div class="title">企业类APP</div>
										<div class="text_info">现在的各行业企业已经进入了新的发展进程，繁荣发展的企业有一个专属的APP可以跟快捷的让人们进行了解</div>
									</div>
								</div>
							</div>
							<Footer></Footer>
						</el-scrollbar>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import Banner from "@/components/banner.vue";
	import Footer from "@/components/footer.vue";
	export default {
		components: {
			Banner,
			Footer,
		},
		data() {
			return {
				isV: true,
				currentPage: 1,
				initialSlide: 1,
				APPswiper: '',
				APPswiperId: 0,
				scrollTop: 0,
			}
		},
		watch: {
			APPswiperId: {
				handler(e) {
					if (e == 1) {
						this.$refs.APPscroll.wrap.scrollTop = 1
						this.APPswiper.disableMousewheelControl()
					}
				}
			}
		},
		mounted() {
			var _this = this
			this.$refs.APPscroll.wrap.onscroll = (e) => {
				_this.scrollTop = e.target.scrollTop
				if (e.target.scrollTop == 0) {
					_this.APPswiper.slidePrev()
					_this.APPswiper.enableMousewheelControl()
				}
			}

			this.APPswiper = new Swiper('.APPswiper', {
				direction: 'vertical',
				loop: false, //不循环
				spaceBetween: 0, // swiper-slide 间的距离为0
				autoplay: false, // 不自动切换
				speed: 700, // 每次切换时长
				// scrollbar: '.swiper-scrollbar', // 滚动条
				mousewheelControl: true, // 开启鼠标切换
				noSwiping: true, // 开启不允许切换
				onSlideChangeEnd: function(swiper) {
					_this.APPswiperId = swiper.activeIndex
				}
			})
		}
	}
</script>

<style lang="scss" scoped>
	.APPdevelopment {
		text-align: center;

		.title_box {
			display: inline-block;
			position: relative;
			font-size: 0.2103rem;
			font-family: MicrosoftYaHei;
			color: #000;
			opacity: 1;
			margin: 0.225rem 0 0.1383rem;
		}

		.title_box::before {
			content: "";
			position: absolute;
			left: -0.4083rem;
			top: 58%;
			transform: translateY(-50%);
			width: 0.2083rem;
			height: 0.2188rem;
			background-image: url("../../static/images/icon/title_left.png");
			background-size: 100% 100%;
		}

		.title_box::after {
			content: "";
			position: absolute;
			right: -0.4083rem;
			top: 58%;
			transform: translateY(-50%);
			width: 0.2083rem;
			height: 0.2188rem;
			background-image: url("../../static/images/icon/title_right.png");
			background-size: 100% 100%;
		}

		.title_info {
			font-size: 0.1146rem;
			font-family: MicrosoftYaHei;
			line-height: 0.2083rem;
			color: #999999;
			opacity: 1;
		}

		.banner_box {
			width: 100vw;
			height: 100vh;
			background-color: pink;
			margin-bottom: 0.308rem;
		}

		.development {
			margin-top: 0.3125rem;
			padding: 0 2.526rem;
			display: flex;

			.phone {
				flex: 1;
				cursor: pointer;

				.img_box {
					width: 0.7917rem;
					height: 0.9271rem;
					margin: 0 auto;
					background-color: #fff;
					background-size: 100% 100%;
					transition: 0.3s;
				}

				.title {
					font-size: 0.1667rem;
					font-family: Microsoft YaHei;
					font-weight: bold;
					line-height: 0.2083rem;
					color: #000000;
					opacity: 1;
					margin: 0.0833rem 0 0.1563rem;
				}

				.text_info {
					font-size: 0.0938rem;
					font-family: MicrosoftYaHei;
					line-height: 0.1458rem;
					color: #666666;
					opacity: 1;
				}
			}

			.IOS {
				margin-right: 0.3906rem;

				.img_box {
					background-image: url("../../static/images/img/ios.png");
				}
			}

			.IOS:hover {
				.img_box {
					background-image: url("../../static/images/img/iosSelected.png");
				}
			}

			.Android {
				margin-left: 0.3906rem;

				.img_box {
					background-image: url("../../static/images/img/android.png");
				}
			}

			.Android:hover {
				.img_box {
					background-image: url("../../static/images/img/androidSelected.png");
				}
			}
		}

		.advantage_box {
			display: flex;
			justify-content: space-between;
			margin: 0.3125rem 1.875rem 0;

			.advantage_li {
				width: 1.2448rem;
				text-align: center;

				.img_box {
					width: 0.7292rem;
					height: 0.7292rem;
					margin: 0 auto;
				}

				.title {
					font-size: 0.1354rem;
					font-family: Microsoft YaHei;
					font-weight: bold;
					line-height: 0.1615rem;
					color: #000000;
					opacity: 1;
					margin: 0.1771rem 0 0.1042rem;
				}

				.text_info {
					font-size: 0.0729rem;
					font-family: MicrosoftYaHei;
					line-height: 0.1146rem;
					color: #666666;
					opacity: 1;
				}
			}
		}

		.type_box {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			margin: 0 1.875rem;
			margin-top: 0.3125rem;

			.type_li {
				width: 1.0417rem;
				margin: 0 0.026rem 0.2605rem;

				.img_box {
					width: 0.625rem;
					height: 0.625rem;
					margin: 0 auto;
				}

				.title {
					font-size: 0.099rem;
					font-family: Microsoft YaHei;
					font-weight: bold;
					line-height: 0.2083rem;
					color: #333333;
					letter-spacing: 0.0104rem;
					opacity: 1;
					margin: 0.0833rem 0.0521rem;
				}

				.text_info {
					font-size: 0.0625rem;
					font-family: MicrosoftYaHei;
					line-height: 0.1146rem;
					color: #666666;
					opacity: 1;
				}
			}
		}

		img {
			width: 100%;
			height: 100%;
		}
	}
</style>